import { LinearScale } from "ui";

export interface Props {
  id: string;
  description: string;
  value?: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
}

export function LinearScaleQuestion(props: Props) {
  return (
    <>
      {props.description && <div>{props.description}</div>}
      <div className="flex justify-center">
        <LinearScale
          min={props.min ?? 1}
          max={props.max ?? 10}
          step={props.step ?? 1}
          value={props.value}
          onChange={props.onChange}
          disabled={props.disabled}
        />
      </div>
    </>
  );
}
